// extracted by mini-css-extract-plugin
export default {"navLink":"styles_navLink__7e6sA","navLinkIcon":"styles_navLinkIcon__H17I8","navLinkText":"styles_navLinkText__OI5R9"};